import MahindraLogo from "@/components/MahindraLogo";

const PRODUCT_NAME = "QFace Attendance System";
const UNIVERSITY_NAME = "Mahindra University";

/**
 * Logo + product wordmark — sidebar, login mobile bar, light/dark surfaces.
 * @param {"sidebar"|"compact"|"light"|"dark"} variant
 */
export default function AppBrandHeader({ variant = "sidebar", className = "", testId = "brand-block" }) {
  const compact = variant === "compact";
  const dark = variant === "dark";

  const titleClass = compact
    ? "text-xs font-extrabold leading-tight"
    : "text-sm font-extrabold leading-snug";

  const subtitleClass = compact
    ? "text-[9px] tracking-[0.16em] mt-0.5"
    : "text-[10px] tracking-[0.18em] mt-1";

  return (
    <div className={`flex items-center gap-3 min-w-0 ${className}`} data-testid={testId}>
      <div
        className={`shrink-0 rounded-xl bg-white shadow-sm ring-1 ring-black/[0.06] ${
          compact ? "p-1.5" : "p-2"
        }`}
      >
        <MahindraLogo
          size="compact"
          transparent
          className={compact ? "max-w-[108px]" : "max-w-[132px]"}
        />
      </div>
      <div className="min-w-0 flex-1">
        <div
          className={`font-heading tracking-tight truncate ${titleClass} ${
            dark ? "text-white" : "text-[#0F172A]"
          }`}
          data-testid="brand-name"
        >
          {compact ? "QFace Attendance" : PRODUCT_NAME}
        </div>
        <div
          className={`font-bold uppercase ${subtitleClass} ${
            dark ? "text-white/65" : "text-[#94A3B8]"
          }`}
        >
          {UNIVERSITY_NAME}
        </div>
      </div>
    </div>
  );
}
